/**
 * Reusable component for displaying error states
 *
 * @param root0
 * @param root0.error
 */
export function ErrorState({ error }: { error: string }) {
	return (
		<div className="inventory-error">
			<p>{error}</p>
		</div>
	);
}
